<template>
  <div
    :class="['cf-menu-list-category-card cf-card cf-flex cf-flex--column cf-flex--align-center cf-flex--justify-center cf-flex--gap-16 cf-cursor-pointer', {
      'cf-menu-list-category-card--hidden': isHidden
    }]"
    @click="categoryCardClickHandler"
  >
    <img
      v-if="categoryImage"
      :class="['cf-image cf-image--thumbnail', isImageEnlarged ? 'cf-image--thumbnail--xlarge' : 'cf-image--thumbnail--large']"
      :src="categoryImage"
      alt="category image"
      onerror="this.src='/images/image-not-found.png';"
    >

    <h2
      :class="['cf-title cf-title--3 cf-no-wrap-ellipsis-multi-line cf-text-align-center', { 'sr-only': isImageEnlarged }]"
    >
      {{ category.displayName }}
    </h2>
  </div>
</template>


<script>
  export default {
    name: 'CfMenuListCategoryCard',

    props: {
      category: {
        type: Object,
        required: true
      },

      categoryIndex: {
        type: Number,
        required: true
      },

      hideName: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      categoryImage() {
        return this.category.images?.length
          ? this.category.images.find(image => image.label === 'kiosk')?.url
          : null;
      },

      isImageEnlarged() {
        return this.hideName && !!this.categoryImage;
      },

      isHidden() {
        return this.category.statementTemplate === 'HiddenTemplate';
      }
    },

    methods: {
      categoryCardClickHandler() {
        this.$emit('category-card-click-handler', { category: this.category, categoryIndex: this.categoryIndex });
      }
    }
  };
</script>
